var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initial_record.is_cp)?_c('el-tooltip',{attrs:{"content":"Created from client portal","placement":"bottom"}},[_c('el-tag',{staticClass:"client-portal-badge-tag status-pill"},[_vm._v("\n    CP\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }